export type RemoteAppVersionPayload = {
  version: string
  buildTime?: string
}

/**
 * Lê `/version.json` na origem com cache-bust (evita resposta stale do SW/HTTP cache).
 */
export async function fetchRemoteAppVersion(): Promise<RemoteAppVersionPayload | null> {
  try {
    const url = `/version.json?t=${Date.now()}`
    const res = await fetch(url, { cache: 'no-store', credentials: 'same-origin' })
    if (!res.ok) return null
    const data: unknown = await res.json()
    if (!data || typeof data !== 'object') return null
    const rec = data as Record<string, unknown>
    const version = rec.version
    if (typeof version !== 'string' || !version.trim()) return null
    const buildTime = rec.buildTime
    return {
      version: version.trim(),
      buildTime: typeof buildTime === 'string' ? buildTime : undefined,
    }
  } catch {
    return null
  }
}
